import * as React from 'react';
import { Link } from 'react-router-dom';
import { II18nMessages } from '../../../../../../services/branding/models';
import { flow, map, forEach } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IStore } from '../../../../../../redux/IStore';
import { IQuoteState } from '../../../../../../services/quote/models';
import Helmet from 'react-helmet';
import { IChannel, IStep } from '../../../../../../data/api/models';

interface IQuoteWizardNavigationProps {
  i18n: II18nMessages;
  steps: any[];
  currentStep: string;
  quote: IQuoteState;
  location: any;
  channel: IChannel;
}

interface IQuoteWizardNavigationState {
  width: number;
}

class QuoteWizardNavigation extends React.Component<IQuoteWizardNavigationProps, IQuoteWizardNavigationState> {
  public state = {
    width: 0,
  };

  public componentDidMount() {
    this.resize();
    window.addEventListener('resize', this.resize.bind(this));
  }

  private resize() {
    this.setState({ width: window.innerWidth <= 1300 });
  }

  private renderItem = (activeKey) => (item, key) => {
    const { quote, quote: { application: { steps = [] } }, location, channel } = this.props;
    const isCoverChoiceLink = item.key !== 'schemeChoice';

    let hasReferrals = null;
    const ANNUAL_KEY = 'Annual Multi-trip';

    forEach(quote.quotes, (quotes) => {
      hasReferrals = quotes &&
        quotes[ANNUAL_KEY] &&
        quotes[ANNUAL_KEY].referrals &&
        quotes[ANNUAL_KEY].referrals.length > 0;
    });

    const isActive = item.key === activeKey;
    let isEnabled = steps.indexOf(item.key) > -1;
    let className = isEnabled ? '' : 'disabled';

    if (location.pathname === '/complete') {
      isEnabled = false;
    }

    if (hasReferrals) {
      isEnabled = false;
    }

    if (isActive) {
      className += ' active';
    }

    let optionsSpace = false;

    if (!this.state.width && item.title === 'Medical') {
      optionsSpace = true;
    }

    const hasCompleteQuote = location.pathname === '/complete';

    return (
      <li key={key} className={hasCompleteQuote ? 'disabled' : className}>
        {optionsSpace && (
           <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
        )}
        <Link to={(isEnabled && isCoverChoiceLink) ? item.route : '#'}
        //      onClick={this.handleWizardClick}
        >
          <span className="number">
            <span className="number-content">
              {key + 1}
            </span>
          </span>
          <span className="step">
            {item.title}
          </span>
        </Link>
      </li>
    );
  }

  // private handleWizardClick = () => {
  //   const { location, steps, currentStep, quote } = this.props;
  //   console.log('location.pathname', location.pathname);
  //   console.log('steps', steps);
  //   console.log('currentStep', currentStep);
  //   console.log('quote.application.steps', quote.application.steps);
  // }

  private getStepsToRender = () =>  {
    const { currentStep } = this.props;
    let activeKey: string = '';

    this.props.steps.forEach((step) => {

      if (step.title === 'Additional Options' && this.state.width) {
        step.title = 'Options';
      } else if (step.title === 'Options' && !this.state.width) {
        step.title = 'Additional Options';
      }

      // Set the active key
      if (step.key === currentStep) {
        activeKey = typeof step.parent !== 'undefined' ? step.parent : step.key;
      }
    });

    const shownSteps = this.props.steps
      .filter((step) => {
        return (typeof step.hidden === 'undefined') || step.hidden === false;
      });

    const steps = shownSteps
      .filter((step) => {
        return typeof step.parent === 'undefined';
      });

    return { steps, activeKey };
  }

  public render() {
    const { steps, activeKey } = this.getStepsToRender();
    const { channel, quote } = this.props;
    const complete = quote.complete;

    const noBorderList = [
      'dia-b2c',
    ];

    const adjustClass = [
      'dia-b2c',
    ];

    const isOnBorder = noBorderList.includes(channel.key);
    const isOnAdjust = adjustClass.includes(channel.key);

    const wizardClass = [
      'wizard',
      isOnBorder ? 'wizard--noBorder' : '',
      isOnAdjust ? 'wizard--adjust' : '',
    ].join(' ');

    if (steps.length === 0) {
      return null;
    }

    let activeItem: IStep = null;

    steps.forEach((step) => {
      if (activeKey !== step.key) {
        return;
      }

      activeItem = step;
    });

    return (
      <div className={wizardClass}>
        {activeItem && (
          <Helmet>
            <title>{activeItem.title}</title>
          </Helmet>
        )}
        {complete && (
          <Helmet>
            <title>{'You are covered'}</title>
          </Helmet>
        )}
        <div className="container">
          {isOnAdjust && (
              <hr />
          )}
          <ul>
            {map(steps, this.renderItem(activeKey))}
          </ul>
        </div>
      </div>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      quote: state.quote,
    }),
  ),
  withRouter,
])(QuoteWizardNavigation);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/components/QuoteWizardNavigation/index.tsx